import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = { 
        maxValue: Number,
        invalidNumber: String,
        minError: String,
        maxError: String
    };
    
    connect() {
        // Find the form and add submit prevention
        this.form = this.element.closest('form');
        if (this.form) {
            this.form.addEventListener('submit', this.preventSubmitIfInvalid.bind(this));
        }
    }
    
    disconnect() {
        if (this.form) {
            this.form.removeEventListener('submit', this.preventSubmitIfInvalid.bind(this));
        }
    }
    
    validate() {
        const value = this.element.value.trim();
        
        if (value === '') {
            this.clearError();
            return;
        }
        
        // Replace comma with dot for parsing
        const numericValue = parseFloat(value.replace(',', '.'));
        
        if (isNaN(numericValue)) {
            const message = this.hasInvalidNumberValue ? this.invalidNumberValue : 'Invalid number';
            this.showError(message);
            return;
        }
        
        if (numericValue < 0) {
            const message = this.hasMinErrorValue ? this.minErrorValue : 'Value must be at least 0';
            this.showError(message);
            return;
        }
        
        const maxValue = this.hasMaxValueValue ? this.maxValueValue : 100;
        if (numericValue > maxValue) {
            const message = this.hasMaxErrorValue ? this.maxErrorValue : `Value must be at most ${maxValue}`;
            this.showError(message);
            return;
        }
        
        this.clearError();
    }
    
    showError(message) {
        // Look for existing error element
        let errorDiv = this.element.parentNode.parentNode.querySelector('.invalid-feedback');
        
        if (!errorDiv) {
            // Create error element if it doesn't exist
            errorDiv = document.createElement('div');
            errorDiv.className = 'invalid-feedback';
            this.element.parentNode.parentNode.appendChild(errorDiv);
        }
        
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
        this.element.classList.add('is-invalid');
    }
    
    clearError() {
        // Look for existing error element
        const errorDiv = this.element.parentNode.parentNode.querySelector('.invalid-feedback');
        if (errorDiv) {
            errorDiv.remove();
        }
        this.element.classList.remove('is-invalid');
    }
    
    preventSubmitIfInvalid(event) {
        // Validate before submission
        this.validate();
        
        // If there's an error, prevent submission
        if (this.element.classList.contains('is-invalid')) {
            event.preventDefault();
            event.stopPropagation();
            
            // Focus on the invalid field
            this.element.focus();
        }
    }
}